module.exports = __webpack_public_path__ + "img/file-document.0e68d39e.svg";